// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"0524c85e","453":"b99f1291","745":"1b090928"}[chunkId] + ".chunk.js";
};